module.exports = __webpack_public_path__ + "static/img/1-5.69fa476d.png";